module.exports = __webpack_public_path__ + "media/intro2.7d1dd3e1.mp4";